import { render, staticRenderFns } from "./ui-news-video.vue?vue&type=template&id=ac0f8ccc&"
import script from "./ui-news-video.vue?vue&type=script&lang=ts&"
export * from "./ui-news-video.vue?vue&type=script&lang=ts&"
import style0 from "./ui-news-video.vue?vue&type=style&index=0&id=ac0f8ccc&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports